import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import { useMountContext } from 'modules/App/context';
import APP from 'stores/APP';

const PasswordSuccess: React.FC = () => {
    const navigate = useNavigate();
    const { isEmbedded } = useMountContext();
    const onClick = () => {
        if (APP.isTiger) {
            window.TigerBridge.quit();
        } else if (isEmbedded) {
            window.location.href = '/login';
        } else {
            navigate('/login');
        }
    };

    return (
        <Card form>
            <h3 className="text-center pt-5">{__('Your password has been successfully changed, please re-login.')}</h3>

            <CardButtonWrap className="mt-5">
                <Button block type="primary" size="large" htmlType="submit" className="btn-submit" onClick={onClick}>
                    {__('Re-Login')}
                </Button>
            </CardButtonWrap>
        </Card>
    );
};

export default PasswordSuccess;
